export default __webpack_public_path__ + "static/media/brothers' in the air.014efdad.jpg";